import styled from 'styled-components';
import { SubmitButtonState } from '.';

interface BaseProps {
	state: SubmitButtonState;
	colors?: {
		disabled?: string;
		hover?: string;
		active?: string;
	};
}

export const Base = styled.div<BaseProps>`
	// i want to shift the icon down by 2px while matching height and width
	// so i reduce height by 2px to 24px
	width: 22px;
	height: 20px;
	padding-top: 2px;

	display: flex;
	align-items: center;
	justify-content: center;
	background: ${({ state, theme, colors }) => {
		if (state === SubmitButtonState.DISABLED) {
			return colors?.disabled || theme.gray[400];
		}
		return colors?.active || theme.gray[1000];
	}};
	&:hover {
		background: ${({ state, theme, colors }) => {
			if (state === SubmitButtonState.DISABLED) {
				return colors?.disabled || theme.gray[400];
			}
			return colors?.hover || theme.gray[700];
		}};
	}
	border-radius: 40px;
`;

interface IconProps {
	// extra px to shift the icon downward — square-edged shapes (STOP) sit
	// optically higher than arrow shapes at the same geometric center, so they
	// need a tiny nudge to match the LINE_ARROW_UP this button is tuned around.
	$nudgeDown: number;
}

export const Icon = styled.div<IconProps>`
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
	transform: translateY(${(p) => p.$nudgeDown}px);
`;
